'use client'

import { useMemo } from 'react'
import { ThemeProvider } from '@mui/material/styles'

// Types
import type { BrandProviderProps } from '@/types/components/providers/brand'

// Configurations
import BrandThemeConfig from '@/config/theme-brand'

// Applies the brand book theme to its children only
const BrandProvider = (props: BrandProviderProps) => {
	// Props
	const { dir, children } = props

	// Variables
	const theme = useMemo(() => BrandThemeConfig(dir), [dir])

	return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default BrandProvider
